module.exports = __webpack_public_path__ + "static/media/da-home-4.d136a33b.jpg";